import { useMutation } from '@tanstack/react-query';

import * as memberMaintenanceServices from 'services/memberMaintenance';
import { sendDownload } from 'config/axios';

export const useDownloadUserInfoGrid = (options = {}) => {
  return useMutation({
    mutationFn: async (params) => {
      const response =
        await memberMaintenanceServices.downloadUserInfoGrid(params);
      if (!response?.isSuccess) {
        throw new Error(response?.message || 'Cannot export data');
      }
      return sendDownload({ url: response?.data?.url });
    },
    ...options,
  });
};
